//-------------------------------------
//  search -- autocomplete
//-------------------------------------
$(function() {
	var isSearching = false;
	$('.js-autocomplete_input').autocomplete({
		source: function(req, res) {
			// 検索種別の選択状態取得
			var elements = $(this.element).closest('form').find('[name=search-type]');
			var selectType = 'library';
			if (elements.prop('tagName') == 'SELECT') {
				selectType = elements.val();
			} else {
				elements.each(function(index, element){
					if ($(element).prop('checked')) {
						selectType = $(element).val();
						return false;
					}
				});
			}
			$.ajax({
				beforeSend: function() {
					if(isSearching) { return false; }
					isSearching = true;
				},
				url: "/api/search-autocomplete/?keyword=" + encodeURIComponent(req.term) + "&type=" + selectType,
				dataType: "json",
				success: function(data) {
					res(data);
				},
				complete: function() {
					isSearching = false;
				}
			});
		},
		autoFocus: false,
		delay: 500,
		minLength: 2
	});
});